import { Col, Container, Row } from 'react-bootstrap';
import Main from '../components/Layout/Main';
import Sidebar from '../components/Layout/Sidebar';
import LeftHero from '../components/Hero/LeftHero';
import Fullwidth from '../components/Layout/Fullwidth';
import LeftText from '../components/TextComponent/LeftText';
import RightText from '../components/TextComponent/RightText';

function About() {
  return (
    <div>
         <Row>
            <Col className="page-header">
                <h1>Über uns</h1>
            </Col>
        </Row>
        <Row className='page-main '>
           <Fullwidth>
                <LeftHero
                title="2022 bricht eine neue Ära an."
                    teaser="Seit der alleinigen Geschäftsleitung durch Claudia Herper arbeiten wir noch intensiver an Ihrer Zufriedenheit, rüsten ständig auf die modernste Technik auf und setzen voll & ganz auf Weiterbildung."
                    image="/speeding_van.png" />
                    <Container className='py-4'>
                        <h1 className='text-center man-headline'>Unsere Firmengeschichte <small>Wie alles begann</small></h1>
                        <LeftText image="/Foto1.jpeg">
                        <h3>Gründung der Düren-Birkesdorfer Wagen- & Räderfabrik</h3>
                        <p>Die Geschichte der Firma Heinrich Heiden führt zurück bis ins Jahr 1880!<br />
    Damals wurde die Firma unter dem Namen "Düren-Birkesdorfer Wagen- und Räderfabrik" vom Stellmacher Heinrich Heiden gegründet. Im Jahre 1932 übernahm der Sohn des Firmengünders, der Schmiedemeister Johann Heiden, die Firma seines Vaters. Kutschen, Karren und Pferdewagen wurden gefertigt.

    </p>
                    </LeftText>
                    <RightText image="/Foto2.jpg">
                        <h3>Erste Betriebserweiterung</h3>
                        <p>Der Fahrzeugbau wurde im Rahmen der Motorisierung im Gütertransport ein wichtiges Standbein. Mehr Aufträge und Mitarbeiter erforderten eine Betriebserweiterung. 1948, beim Neuanfang nach dem Krieg, war die Landwirtschaft Hauptkunde bei Heiden. Luftbereifte Ackerwagen waren gefragt.</p>
                    </RightText>
                    <LeftText image="/Foto3.jpeg">
                        <h3>Gründung der GmbH</h3>
                        <p>Im Jahre 1953 übernahm der Fahrzeug- und Karosserie-Ingenieur Heinrich Heiden die Firma seines Vaters. Anhänger bis 16 Tonnen, Pritschen und Kofferaufbauten wurden gefertigt und alle Reparaturen wurden ausgeführt. Das enorme Wirtschaftswachstum während der Aufbauphase ließ das Firmengelände an der Zollhausstraße an seine räumlichen Grenzen stoßen. Im Jahre 1960 wurde deswegen in der Schüllsmühle der heutige Firmensitz eröffnet. Seit Januar 1965 ist die Firma Heinrich Heiden GmbH & Co. KG Servicepartner der MAN Truck & Bus Deutschland GmbH, München. Darüber hinaus sind wir seit Jahrzehnten Vertragspartner aller bedeutenden Bremsen-, Hydraulik-, Kipper- und Winterdienstgeräte- hersteller. Im Jahre 1985 übernahmen die Mitarbeiter Axel Ulrich und Willi Schüller die Firmenleitung. Unser Seniorchef, Heinrich Heiden, verstarb im Jahre 1992.</p>
                    </LeftText>
                    <RightText image="/Foto4.jpg">
                        <h3>Erneuerung des Firmengebäudes</h3>
                        <p>Im Jahre 2005 wurde der Büro- und Lagertrakt nach den Vorgaben der MAN komplett erneuert. Im Jahre 2010 übernahm Claudia Herper die Geschäftsführung von ihrem Vater, zusammen mit Willi Schüller. Im Jahre 2022 schied Willi Schüller aus der Firmenleitung aus. Claudia Herper ist seitdem alleinige Geschäftsführerin. Weiterhin wurde die Werkstattkompetenz durch neue, modernste Diagnosegeräte gesteigert. Wir bieten sämtliche Wartungs- und Reparaturarbeiten, einschließlich Fehlerdiagnose und deren Behebung, für alle Fahrzeuge an.</p>
                    </RightText>
                </Container>
           </Fullwidth>
        </Row>
    </div>
  );
}

export default About;